// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.dash-balance {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.dash-balance .dash-balance-value {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.quick-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.quick-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px 14px 16px;
  border: 1px solid var(--gray-200);
  border-radius: 14px;
  color: var(--color-primary);
  transition: all 0.15s ease;
}
.quick-card:hover {
  border-color: var(--gray-300);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  color: var(--color-primary);
}
.quick-card:hover .quick-chev {
  transform: translateX(3px);
  color: var(--color-primary);
}
.quick-card.accent {
  background: var(--color-accent);
  border-color: var(--color-accent);
}
.quick-card.accent .quick-icon {
  background: rgba(0, 0, 0, 0.08);
}
.quick-card.accent .quick-text {
  color: #3a4a10;
}
.quick-card .quick-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
}
.quick-card .quick-copy {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}
.quick-card .quick-title {
  font-weight: 700;
  font-size: 14px;
}
.quick-card .quick-text {
  font-size: 12px;
  color: var(--gray-500);
}
.quick-card .quick-chev {
  color: var(--gray-500);
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.setup-progress {
  height: 6px;
  border-radius: 6px;
  background: var(--gray-100);
  overflow: hidden;
}
.setup-progress span {
  display: block;
  height: 100%;
  background: var(--color-accent-dark);
  border-radius: 6px;
}

.setup-step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid var(--gray-100);
  font-size: 14px;
  font-weight: 500;
  color: var(--color-primary);
}
.setup-step:hover {
  color: #000;
}
.setup-step.done {
  color: var(--gray-500);
  text-decoration: line-through;
}
.setup-step .setup-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--gray-300);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.setup-step.done .setup-check {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: #000;
}

.notif-mini li {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid var(--gray-100);
}
.notif-mini li:first-child {
  border-top: none;
  padding-top: 0;
}
.notif-mini li .notif-mini-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .mobile-only {
    display: block;
  }
  .dash-hero {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    margin-bottom: 16px;
  }
  .dash-balance {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    background: var(--color-primary);
    color: #fff;
    border-radius: 16px;
    padding: 16px 18px;
  }
  .dash-balance .text-muted {
    color: rgba(255, 255, 255, 0.65) !important;
    flex-basis: 100%;
  }
  .dash-balance .dash-balance-value {
    font-size: 28px;
  }
  .dash-balance .link-accent {
    color: #000;
    background: var(--color-accent);
    padding: 7px 14px;
    border-radius: 20px;
    text-decoration: none;
  }
  .quick-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    margin-bottom: 20px;
  }
  .quick-card {
    flex-direction: column;
    text-align: center;
    gap: 6px;
    padding: 12px 4px;
    border: none;
    background: transparent;
  }
  .quick-card.accent {
    background: transparent;
  }
  .quick-card.accent .quick-icon {
    background: var(--color-accent);
  }
  .quick-card .quick-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
  }
  .quick-card .quick-title {
    font-size: 11.5px;
    font-weight: 600;
    line-height: 1.2;
  }
  .quick-card .quick-text,
  .quick-card .quick-chev {
    display: none;
  }
  .quick-card:hover {
    box-shadow: none;
  }
  .summary-strip {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    margin: 0 -16px 20px;
    padding: 0 16px 4px;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 16px;
    scrollbar-width: none;
  }
  .summary-strip::-webkit-scrollbar {
    display: none;
  }
  .summary-chip {
    scroll-snap-align: start;
    flex: 0 0 auto;
    min-width: 128px;
    border: 1px solid var(--gray-200);
    border-radius: 14px;
    padding: 12px 14px;
    background: #fff;
    color: var(--color-primary);
    text-align: left;
  }
  .summary-chip .summary-num {
    display: block;
    font-size: 26px;
    font-weight: 800;
    line-height: 1.1;
  }
  .summary-chip .summary-label {
    display: block;
    font-size: 12px;
    color: var(--gray-500);
    font-weight: 500;
  }
  .mobile-market {
    margin-bottom: 20px;
  }
  .mobile-market .crude-grid {
    display: flex;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAGA;EACC,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;AAAD;AAEC;EACC,6BAAA;EACA,0CAAA;EACA,2BAAA;AAAF;AAEE;EACC,0BAAA;EACA,2BAAA;AAAH;AAIC;EACC,+BAAA;EACA,iCAAA;AAFF;AAIE;EACC,+BAAA;AAFH;AAIE;EACC,cAAA;AAFH;AAMC;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAOC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AALF;AAQC;EACC,gBAAA;EACA,eAAA;AANF;AASC;EACC,eAAA;EACA,sBAAA;AAPF;AAUC;EACC,sBAAA;EACA,cAAA;EACA,gCAAA;AARF;;AAYA;EACC,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AATD;AAWC;EACC,cAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AATF;;AAaA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAVD;AAYC;EACC,WAAA;AAVF;AAaC;EACC,sBAAA;EACA,6BAAA;AAXF;AAcC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAZF;AAeC;EACC,+BAAA;EACA,iCAAA;EACA,WAAA;AAbF;;AAiBA;EACC,aAAA;EACA,SAAA;EACA,eAAA;EACA,qCAAA;AAdD;AAgBC;EACC,gBAAA;EACA,cAAA;AAdF;AAiBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAfF;;AAoBA;EACC,aAAA;AAjBD;;AAoBA;EACC;IACC,cAAA;EAjBA;EAoBD;IACC,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;EAlBA;EAqBD;IACC,mBAAA;IACA,mBAAA;IACA,8BAAA;IACA,eAAA;IACA,gCAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;EAnBA;EAqBA;IACC,2CAAA;IACA,gBAAA;EAnBD;EAsBA;IACC,eAAA;EApBD;EAuBA;IACC,WAAA;IACA,+BAAA;IACA,iBAAA;IACA,mBAAA;IACA,qBAAA;EArBD;EAyBD;IACC,qCAAA;IACA,QAAA;IACA,mBAAA;EAvBA;EA0BD;IACC,sBAAA;IACA,kBAAA;IACA,QAAA;IACA,iBAAA;IACA,YAAA;IACA,uBAAA;EAxBA;EA0BA;IACC,uBAAA;EAxBD;EA0BC;IACC,+BAAA;EAxBF;EA4BA;IACC,WAAA;IACA,YAAA;IACA,mBAAA;EA1BD;EA6BA;IACC,iBAAA;IACA,gBAAA;IACA,gBAAA;EA3BD;EA8BA;;IAEC,aAAA;EA5BD;EA+BA;IACC,gBAAA;EA7BD;EAiCD;IACC,aAAA;IACA,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,mBAAA;IACA,6BAAA;IACA,sBAAA;IACA,qBAAA;EA/BA;EAiCA;IACC,aAAA;EA/BD;EAmCD;IACC,wBAAA;IACA,cAAA;IACA,gBAAA;IACA,iCAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;IACA,2BAAA;IACA,gBAAA;EAjCA;EAmCA;IACC,cAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;EAjCD;EAoCA;IACC,cAAA;IACA,eAAA;IACA,sBAAA;IACA,gBAAA;EAlCD;EAsCD;IACC,mBAAA;EApCA;EAsCA;IACC,aAAA;IACA,SAAA;EApCD;AACF","sourcesContent":[".dash-hero {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-end;\n\tflex-wrap: wrap;\n\tgap: 16px;\n\tmargin-bottom: 20px;\n}\n\n.dash-balance {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tgap: 2px;\n\n\t.dash-balance-value {\n\t\tfont-size: 26px;\n\t\tfont-weight: 800;\n\t\tline-height: 1.1;\n\t}\n}\n\n.quick-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n\tgap: 12px;\n\tmargin-bottom: 24px;\n}\n\n.quick-card {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding: 14px 14px 14px 16px;\n\tborder: 1px solid var(--gray-200);\n\tborder-radius: 14px;\n\tcolor: var(--color-primary);\n\ttransition: all 0.15s ease;\n\n\t&:hover {\n\t\tborder-color: var(--gray-300);\n\t\tbox-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n\t\tcolor: var(--color-primary);\n\n\t\t.quick-chev {\n\t\t\ttransform: translateX(3px);\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&.accent {\n\t\tbackground: var(--color-accent);\n\t\tborder-color: var(--color-accent);\n\n\t\t.quick-icon {\n\t\t\tbackground: rgba(0, 0, 0, 0.08);\n\t\t}\n\t\t.quick-text {\n\t\t\tcolor: #3a4a10;\n\t\t}\n\t}\n\n\t.quick-icon {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 10px;\n\t\tbackground: var(--gray-100);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.quick-copy {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\tmin-width: 0;\n\t}\n\n\t.quick-title {\n\t\tfont-weight: 700;\n\t\tfont-size: 14px;\n\t}\n\n\t.quick-text {\n\t\tfont-size: 12px;\n\t\tcolor: var(--gray-500);\n\t}\n\n\t.quick-chev {\n\t\tcolor: var(--gray-500);\n\t\tflex-shrink: 0;\n\t\ttransition: transform 0.15s ease;\n\t}\n}\n\n.setup-progress {\n\theight: 6px;\n\tborder-radius: 6px;\n\tbackground: var(--gray-100);\n\toverflow: hidden;\n\n\tspan {\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tbackground: var(--color-accent-dark);\n\t\tborder-radius: 6px;\n\t}\n}\n\n.setup-step {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding: 10px 0;\n\tborder-top: 1px solid var(--gray-100);\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: var(--color-primary);\n\n\t&:hover {\n\t\tcolor: #000;\n\t}\n\n\t&.done {\n\t\tcolor: var(--gray-500);\n\t\ttext-decoration: line-through;\n\t}\n\n\t.setup-check {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tborder-radius: 50%;\n\t\tborder: 2px solid var(--gray-300);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t&.done .setup-check {\n\t\tbackground: var(--color-accent);\n\t\tborder-color: var(--color-accent);\n\t\tcolor: #000;\n\t}\n}\n\n.notif-mini li {\n\tdisplay: flex;\n\tgap: 10px;\n\tpadding: 10px 0;\n\tborder-top: 1px solid var(--gray-100);\n\n\t&:first-child {\n\t\tborder-top: none;\n\t\tpadding-top: 0;\n\t}\n\n\t.notif-mini-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 8px;\n\t\tbackground: var(--gray-100);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t}\n}\n\n// ---------- Phone ----------\n.mobile-only {\n\tdisplay: none;\n}\n\n@media (max-width: 768px) {\n\t.mobile-only {\n\t\tdisplay: block;\n\t}\n\n\t.dash-hero {\n\t\tflex-direction: column;\n\t\talign-items: stretch;\n\t\tgap: 14px;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t.dash-balance {\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tbackground: var(--color-primary);\n\t\tcolor: #fff;\n\t\tborder-radius: 16px;\n\t\tpadding: 16px 18px;\n\n\t\t.text-muted {\n\t\t\tcolor: rgba(255, 255, 255, 0.65) !important;\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t.dash-balance-value {\n\t\t\tfont-size: 28px;\n\t\t}\n\n\t\t.link-accent {\n\t\t\tcolor: #000;\n\t\t\tbackground: var(--color-accent);\n\t\t\tpadding: 7px 14px;\n\t\t\tborder-radius: 20px;\n\t\t\ttext-decoration: none;\n\t\t}\n\t}\n\n\t.quick-grid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 8px;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.quick-card {\n\t\tflex-direction: column;\n\t\ttext-align: center;\n\t\tgap: 6px;\n\t\tpadding: 12px 4px;\n\t\tborder: none;\n\t\tbackground: transparent;\n\n\t\t&.accent {\n\t\t\tbackground: transparent;\n\n\t\t\t.quick-icon {\n\t\t\t\tbackground: var(--color-accent);\n\t\t\t}\n\t\t}\n\n\t\t.quick-icon {\n\t\t\twidth: 52px;\n\t\t\theight: 52px;\n\t\t\tborder-radius: 16px;\n\t\t}\n\n\t\t.quick-title {\n\t\t\tfont-size: 11.5px;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 1.2;\n\t\t}\n\n\t\t.quick-text,\n\t\t.quick-chev {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\n\t.summary-strip {\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t\toverflow-x: auto;\n\t\tmargin: 0 -16px 20px;\n\t\tpadding: 0 16px 4px;\n\t\tscroll-snap-type: x mandatory;\n\t\tscroll-padding: 0 16px;\n\t\tscrollbar-width: none;\n\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.summary-chip {\n\t\tscroll-snap-align: start;\n\t\tflex: 0 0 auto;\n\t\tmin-width: 128px;\n\t\tborder: 1px solid var(--gray-200);\n\t\tborder-radius: 14px;\n\t\tpadding: 12px 14px;\n\t\tbackground: #fff;\n\t\tcolor: var(--color-primary);\n\t\ttext-align: left;\n\n\t\t.summary-num {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 26px;\n\t\t\tfont-weight: 800;\n\t\t\tline-height: 1.1;\n\t\t}\n\n\t\t.summary-label {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--gray-500);\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n\n\t.mobile-market {\n\t\tmargin-bottom: 20px;\n\n\t\t.crude-grid {\n\t\t\tdisplay: flex;\n\t\t\tgap: 10px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
